// extracted by mini-css-extract-plugin
export default {"container":"SY-z","title":"TY-z","link":"UY-z"};